import Newsletters from '../components/newletters.js';
import { Link } from 'react-router-dom';
//import Logo from '../images/3keyswhtbg.png';

export default function Ft(){
    return(
        <div className="row ft">
            <div className="col-sm-3 ft-column">
                {/*<img src={Logo} alt='3 Keys Logo' width='200px' height='100px' />*/}
               
                <h4>Lagos Office</h4>
                <p>21, Abiola Generation Street, Saka, Ajegunle/Alagbado,<br />Lagos, Nigeria.</p>
                
                <p>International Desk: <br />
                Mrs Obafemi, obafemi@3keyslogisticsltd.com.ng<br />
                +234 803 930 8845,<br />+234 802 056 4173</p>
                <p>Email: info@3keyslogisticsltd.com.ng</p>

                <br />
                <h4>Abuja Office:</h4>
                <p>First Generational Plaza, Aco Estate, Lugbe, Phase 2, Abuja</p>

            </div>
            <div className="col-sm-3 ft-column">
                <h3>Quick Links</h3>
                <br />
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About Us</Link>
                    </li>
                    <li>
                        <Link to="/ourservices">Our Services</Link>
                    </li>
                    <li>
                        <Link to="/latestnews">latest News</Link>
                    </li>
                    <li>
                        <Link to="/contactus">Contact Us</Link>
                    </li>
                </ul>
            </div>
            <div className="col-sm-3 ft-column">
            <h3>Follow us</h3>
                <br />
                <ul>
                    <li>facebook</li>
                    <li>X</li>
                    <li>Instagram</li>
                    <li>Pinterest</li>
                    <li>Tiktok</li>
                </ul>
            </div>
            <div className="col-sm-3 ft-column">
                <h3>News Letter</h3>
                <Newsletters />    
            </div>      
        </div>
    );
}